import { useState } from "react";
import {
  Button,
  ButtonGroup,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { requestApi } from "../../actions/api";
import { GetLanguageString } from "../helper/Components";
import { GetCustomStyles } from "../helper/Method";
import AddressType from "./addressType/AddressType";
import Books from "./books/Books";
import ContactType from "./contactType/ContactType";
import CourseType from "./courseType/CourseType";
import DocumentTag from "./documentTags/DocumentTags";
import DocumentType from "./documentType/DocumentTypes";
import Education from "./education/Education";
import EventType from "./eventType/EventType";
import HabibProgressType from "./habibprogress/HabibProgressType";
import SaveCropFile from "./helper/SaveCropFile";
import CounsellingQuestions from "./letterForCounselling/CounsellingQuestions/CounsellingQuestions";
import LetterForCounselling from "./letterForCounselling/LetterForCounselling";
import MemberType from "./memberType/MemberType";
import NotificationType from "./notificationType/NotificationType";
import Pledges from "./pledges/Pledges";
import ResponsibilityType from "./responsibilityType/ResponsibilityType";
import SetupBook from "./setupsyllabus/SetupBook";
import TutorialCategory from "./tutorialCategory/TutorialCategory";
import UnitType from "./unitType/UnitType";
import FinanceTab from "./finance/FinanceTab";
import GeneralConfigType from "./generalConfig/GeneralConfigType";
//import SetupSyllabusBook from "./setupsyllabus/SetupSyllabusBook";

const Configuration = () => {
  const [activeTab, setActiveTab] = useState("course");
  const [modal, setModal] = useState(false);

  const tabs = [
    {
      id: "course",
      label: "settings_course_type",
      component: <CourseType activeTab={activeTab} />,
    },
    {
      id: "event",
      label: "settings_event_type",
      component: <EventType activeTab={activeTab} />,
    },
    {
      id: "member",
      label: "settings_member_type",
      component: <MemberType activeTab={activeTab} />,
    },
    {
      id: "unit",
      label: "dashboard_event_page_unit_type",
      component: <UnitType activeTab={activeTab} />,
    },
    {
      id: "responsibility",
      label: "settings_responsibilities",
      component: <ResponsibilityType activeTab={activeTab} />,
    },

    {
      id: "notification",
      label: "settings_notification_type",
      component: <NotificationType activeTab={activeTab} />,
    },
    {
      id: "category",
      label: "tutorial_category",
      component: <TutorialCategory activeTab={activeTab} />,
    },
    {
      id: "education",
      label: "member_education",
      component: <Education activeTab={activeTab} />,
    },
    {
      id: "pledges",
      label: "member_member_detail_select_pledges_type",
      component: <Pledges activeTab={activeTab} />,
    },
    {
      id: "contactType",
      label: "settings_contact_type",
      component: <ContactType activeTab={activeTab} />,
    },
    {
      id: "addressType",
      label: "settings_address_type",
      component: <AddressType activeTab={activeTab} />,
    },
    {
      id: "letterForCounselling",
      label: "settings_letter_for_counselling",
      component: <LetterForCounselling activeTab={activeTab} />,
    },
    {
      id: "counsellingQuestions",
      label: "settings_counselling_questions",
      component: <CounsellingQuestions activeTab={activeTab} />,
    },
    {
      id: "documentType",
      label: "settings_document_types",
      component: <DocumentType activeTab={activeTab} />,
    },
    {
      id: "documentTags",
      label: "document_document_tags",
      component: <DocumentTag activeTab={activeTab} />,
    },
    {
      id: "habibprogress",
      label: "habib_progress_type",
      component: <HabibProgressType activeTab={activeTab} />,
    },
    {
      id: "books",
      label: "syllabus",
      component: <Books activeTab={activeTab} />,
    },
    {
      id: "setupBook",
      label: "syllabus_book",
      component: <SetupBook activeTab={activeTab} />,
    },
    {
      id: "generalConfig",
      label: "general_config_type",
      component: <GeneralConfigType activeTab={activeTab} />,
    },
    {
      id: "finance",
      label: "finance",
      component: <FinanceTab activeTab={activeTab} />,
    },
  ];
  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const [isLoading, setIsLoading] = useState(false);

  const handleAuthorization = async () => {
    setIsLoading(true);

    try {
      // Call the backend to get the Google authorization URL
      const response = await requestApi("googledrive/").authorizeGoogleDrive();

      // Check if the response is successful
      if (response.status === 200 && response.data?.authUrl) {
        // Open the Google OAuth authorization page in a new window
        window.open(response.data.authUrl, "_blank");
      } else {
        console.log("Failed to retrieve the authorization URL.");
      }
    } catch (error) {
      console.error("Error during authorization:", error);
      console.log("An error occurred during the authorization process.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="wrapper wrapper-content wrapper-custom">
      {modal ? <SaveCropFile /> : null}
      <Row>
        <Col md={12}>
          <ButtonGroup className={GetCustomStyles().btn_group_style}>
            <Button
              className="m-b float-right"
              color="primary"
              size="sm"
              disabled={isLoading}
              onClick={handleAuthorization}
            >
              {isLoading ? "Authorizing..." : "Authorize Google Drive"}
            </Button>{" "}
            <Button
              className="m-b float-right"
              color="success"
              size="sm"
              onClick={() => setModal(true)}
            >
              Call the Api
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <div className="tabs-container">
            <Nav tabs>
              {tabs.map((tab) => (
                <NavItem key={tab.id}>
                  <NavLink
                    className={activeTab === tab.id ? "active" : ""}
                    onClick={() => toggleTab(tab.id)}
                  >
                    <GetLanguageString props={tab.label} />
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
            <TabContent activeTab={activeTab}>
              {tabs.map((tab) => (
                <TabPane key={tab.id} tabId={tab.id}>
                  <div
                    className="panel-body"
                    style={{
                      backgroundColor:
                        tab.id === "finance" ? "#fdfcfcff" : "white",
                    }}
                  >
                    {tab.component}
                  </div>
                </TabPane>
              ))}
            </TabContent>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Configuration;
